import AssistivLogoSVG from '@/assets/branding/assistiv/assistiv-new.svg';
import AssistivLogoSmallSVG from '@/assets/branding/assistiv/assistiv-new-small.svg';
import AssistivRobot from '@/assets/branding/assistiv/assistiv-robot.png';

export { AssistivLogoSVG, AssistivLogoSmallSVG, AssistivRobot };
